import { setErrorPageAnalytics } from '@avalara/bat-apps-shared/helpers/analytics';
import * as React from 'react';
import conf from '../conf';
import analytics from '../lib/analytics';

// Components
import SystemFailure from '../components/error-boundary';

// Styles
import { FailurePageWrapper } from '../components/styled/components/error-boundary';

// Types

type Props = {
  children: React.ReactNode;
};

type State = {
  hasError: boolean;
};

type Error = {
  name: string;
  message: string;
  stack: string;
};

type Info = {
  componentStack: string;
};

class ErrorBoundary extends React.Component<Props, State> {
  state = { hasError: false };

  componentDidCatch(error: Error, info: Info) {
    const { name, message, stack } = error;
    const { componentStack } = info;

    analytics.track('CLIENT_FATAL_ERROR', {
      name,
      message,
      stack,
      componentStack,
      error: true,
    });
    this.setState({ hasError: true });
    setErrorPageAnalytics(500, window.location.pathname);
  }

  render() {
    if (this.state.hasError) {
      return (
        <FailurePageWrapper backgroundImage={`${conf.ASSET_PATH}/assets/images/error-500.jpg`}>
          <div>
            <SystemFailure />
          </div>
        </FailurePageWrapper>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
